import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { ProviderControllerApi } from "../../../services";
import { ProviderListItem } from "../../../types/provider-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

export interface UseProvidersForReassignProps {
  pagination: DGT_Pagination;
  searchKey?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export function useProvidersForReassign({
  pagination,
  searchKey,
  xTENANTID,
  enabled = true,
}: UseProvidersForReassignProps): useBaseContent<ProviderListItem> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  return useQuery({
    queryKey: [
      "providers-for-reassign",
      pageSize,
      pageIndex,
      searchKey,
      xTENANTID,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: enabled,
    retry: (count) => count < 3,
    queryFn: async () => {
      return new ProviderControllerApi(getConfigObject())
        .getProvidersForReassign(
          pageIndex,
          pageSize,
          searchKey ? searchKey : undefined,
          xTENANTID
        )
        .then((res) => asPaginatedContent<ProviderListItem>(res?.data));
    },
  });
}
